import { render, staticRenderFns } from "./SideBarSetting.vue?vue&type=template&id=5e03bcb0&scoped=true&"
import script from "./SideBarSetting.vue?vue&type=script&lang=js&"
export * from "./SideBarSetting.vue?vue&type=script&lang=js&"
import style0 from "./SideBarSetting.vue?vue&type=style&index=0&id=5e03bcb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03bcb0",
  null
  
)

export default component.exports